import React from "react";
import styled from "styled-components";

export const StepContent = styled.p`
	color: #212323;
	font-family: Mallory;
	font-size: 16px;
	font-weight: 300;
	margin-top: 0;
	letter-spacing: 0;
	line-height: 28px;
	@media (max-width: 767px){
		display: none;
	}
`;

export const StepTitle = styled.h4`
	color: #050505;
	font-family: Mallory-Book;
	margin-bottom: 6px;
	font-size: 24px;
	font-weight: 300;
	letter-spacing: 1px;
	line-height: 22px;
	@media (max-width: 767px){
		display: none;
	}
`;

export const StepImage = styled.img`
	max-height: 300px;
	width: auto;
	@media (max-width: 767px){
		display: none;
	}
`;

export const Container = styled.div`
	display: flex;
	flex-wrap: wrap;
	max-width: 815px;
	margin: 0px auto 60px;
	align-content: center;
    justify-content: center;
    align-items: center;
	@media (max-width: 767px){
		display: none;
	}
`;


export const Col = styled.div`
	flex: 0 1 47%;
	@media (max-width: 767px){
		display: none;
	}
`;

export const MobileImage = styled.img`
	@media(min-width: 767px){
		display: none;
	}
	@media (max-width: 767px){
		max-height: 338px;
		width: auto;
	}
`;

export const MobileTitle = styled.h4`
	@media(min-width: 767px){
		display: none;
	}
	color: #050505;
	font-family: Canela;
	font-size: 24px;
	font-weight: 300;
	letter-spacing: 1px;
	line-height: 22px;
	margin: 0;
`;

export const MobileContent = styled.p`
	@media(min-width: 767px){
		display: none;
	}
	color: #212323;
	font-family: Mallory;
	font-size: 16px;
	font-weight: 300;
	letter-spacing: 0;
	line-height: 28px;

`;

export const MobileContainer = styled.div`
	margin: 0 18px 30px;
	
`;